import { render, staticRenderFns } from "./alarmBridgePacom.vue?vue&type=template&id=3c67b6ab&scoped=true"
import script from "./alarmBridgePacom.vue?vue&type=script&lang=js"
export * from "./alarmBridgePacom.vue?vue&type=script&lang=js"
import style0 from "./alarmBridgePacom.vue?vue&type=style&index=0&id=3c67b6ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c67b6ab",
  null
  
)

export default component.exports